import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M19 13a.97.97 0 0 1-.713-.288A.96.96 0 0 1 18 12q0-.425.288-.713A.96.96 0 0 1 19 11h2q.425 0 .713.288T22 12a.97.97 0 0 1-.288.713A.96.96 0 0 1 21 13zm-.6 6.4-1.6-1.2a.91.91 0 0 1-.4-.65 1.03 1.03 0 0 1 .2-.75.91.91 0 0 1 .65-.4q.4-.05.75.2l1.6 1.2a.91.91 0 0 1 .4.65q.05.4-.2.75a.91.91 0 0 1-.65.4 1.03 1.03 0 0 1-.75-.2m-.4-12a1.03 1.03 0 0 1-.75.2.91.91 0 0 1-.65-.4 1.03 1.03 0 0 1-.2-.75.91.91 0 0 1 .4-.65l1.6-1.2q.35-.25.75-.2a.91.91 0 0 1 .65.4q.25.35.2.75a.91.91 0 0 1-.4.65zM5 19v-4H4q-.825 0-1.413-.588A1.92 1.92 0 0 1 2 13v-2q0-.825.588-1.413A1.92 1.92 0 0 1 4 9h4l3.475-2.1q.5-.3 1.012 0 .511.3.513.875v8.45q0 .575-.513.875-.514.3-1.012 0L8 15H7v4zm9-3.65v-6.7q.675.6 1.088 1.463.413.862.412 1.887 0 1.025-.413 1.888A4.6 4.6 0 0 1 14 15.35m-3-.9v-4.9L8.55 11H4v2h4.55z"
    }, null, -1)
  ]))]))
}
export default { render: render }